import React from "react";
import {
    StyledListChecked,
    StyledListUnordered,
    StyledListOrdered
} from "./list.styles";

const StyledList = ({ type, ...props }) => {
    switch (type) {
        case "ordered":
            return <StyledListOrdered {...props} />;
        case "checked":
            return <StyledListChecked {...props} />;
        case "unordered":
        default:
            return <StyledListUnordered {...props} />;
    }
};

const List = props => {
    const checkList = props.items.map((item, index) => (
        <li key={index}>{item}</li>
    ));
    return <StyledList {...props}>{checkList}</StyledList>;
};

export default List;
